import React, { useState } from 'react';

import { Config } from '../../../config';
import { selectUser } from '../../../redux/reducers/userReducer';
import { useLoader } from '../../../hooks/useLoader';
import { useSelector } from 'react-redux';

// Earliest story on the platform; the pre-2026 archive lives in the
// client's Obsidian vault, not in Firestore.
const EARLIEST_STORY_DATE = '2026-01-01';

const todayISO = () => new Date().toISOString().slice(0, 10);

const ExportStories = () => {
  const [since, setSince] = useState(EARLIEST_STORY_DATE);
  const [until, setUntil] = useState(todayISO());
  const [error, setError] = useState('');

  const user = useSelector(selectUser);
  const { showLoading } = useLoader();

  const handleDownload = async () => {
    setError('');
    if (since > until) {
      setError('"From" date must be before the "To" date.');
      return;
    }
    try {
      showLoading(true);
      const email = user.data?.user.user_id || '';
      const url = `${Config.endPoint.getArchiveExport}?adminEmail=${encodeURIComponent(
        email
      )}&since=${since}&until=${until}`;
      const response = await fetch(url);
      if (!response.ok) {
        const body = await response.json().catch(() => null);
        setError(
          body?.message ||
            `Export failed (${response.status}). Please try again.`
        );
        return;
      }
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `eurointelligence-stories-${since}-to-${until}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(link.href);
    } catch (e) {
      setError('Something went wrong, please try again.');
    } finally {
      showLoading(false);
    }
  };

  return (
    <div style={{ padding: 30, maxWidth: 560 }}>
      <h2 style={{ marginTop: 0 }}>Export Stories</h2>
      <p style={{ color: '#444', lineHeight: 1.5 }}>
        Download all approved stories in the selected date range as a zip of
        Markdown files (one file per story, in the Obsidian vault format:
        &ldquo;YYYY-MM-DD — Title.md&rdquo;).
      </p>
      <div style={{ display: 'flex', gap: 20, marginTop: 20 }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          From
          <input
            type='date'
            value={since}
            min={EARLIEST_STORY_DATE}
            max={todayISO()}
            onChange={(e) => setSince(e.target.value)}
            style={{ padding: 8, fontSize: 15 }}
          />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          To
          <input
            type='date'
            value={until}
            min={EARLIEST_STORY_DATE}
            max={todayISO()}
            onChange={(e) => setUntil(e.target.value)}
            style={{ padding: 8, fontSize: 15 }}
          />
        </label>
      </div>
      <button
        onClick={handleDownload}
        style={{
          marginTop: 25,
          padding: '10px 24px',
          fontSize: 16,
          backgroundColor: '#001f3d',
          color: 'white',
          border: 'none',
          borderRadius: 8,
          cursor: 'pointer',
        }}
      >
        Download zip
      </button>
      {error && (
        <p style={{ color: '#a00', marginTop: 15 }}>{error}</p>
      )}
    </div>
  );
};

export default ExportStories;
